export default class {
  type = ''; // ACCOMODATION | SKIPASS
  quantity = 0;
  price = 0;
  confirmed = false;
  meta = {};

  belongsTo = -1;

  editableQuantity = true;

  discountedPrices = {};
  discountedPrice = null;

  constructor() {
    return true;
  }

  totalPrice() {
    return this.quantity * this.price;
  }

  static number(no) {
    return parseInt(no || 0, 10);
  }
}



// WEBPACK FOOTER //
// ./src/classes/CartObject.js